<template>
<header class="wenhui-tech-header">
    <div class="tech-header-container">
        <!-- 左侧logo和品牌 -->
        <div class="tech-header-brand">
            <router-link to="/" class="tech-logo">
                <img src="@/assets/images/logo-v2.png" alt="闲农日季" class="logo-image">
                <span class="tech-brand-name">闲农日季</span>
            </router-link>
        </div>

        <!-- 右侧导航菜单 -->
        <div class="tech-header-nav">
            <div class="tech-nav-menu">
                <div v-for="item in navItems" :key="item.name" class="tech-nav-item" :class="{active: activeIndex === item.path}" @click="navigateTo(item.path)">
                    <span class="tech-nav-text">{{ item.text }}</span>
                    <div class="tech-nav-line"></div>
                </div>
            </div>

            
        </div>

        
    </div>
</header>
</template>

<script>
export default {
    name: "WenhuiTechHeader",
    data() {
        return {
            mobileMenuVisible: false,
            navItems: [{
                    path: "/",
                    name: "why-home",
                    text: "首页"
                },
                {
                    path: "/about",
                    name: "why-about",
                    text: "关于我们"
                },
                // {
                //     path: "/services",
                //     name: "why-services",
                //     text: "服务项目"
                // },
                // {
                //     path: "/cases",
                //     name: "why-cases",
                //     text: "案例展示"
                // },
                {
                    path: "/support",
                    name: "why-support",
                    text: "技术支持"
                },
                {
                    path: "/privacy",
                    name: "why-privacy",
                    text: "隐私政策"
                }
            ],
        };
    },
    computed: {
        activeIndex() {
            return this.$route.path;
        },
    },
    methods: {
        navigateTo(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
            this.mobileMenuVisible = false;
        },
        toggleMobileMenu() {
            //this.mobileMenuVisible = !this.mobileMenuVisible;
        }
    },
};
</script>

<style lang="scss" scoped>
.wenhui-tech-header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    .tech-header-container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80px;
    }

    .tech-header-brand {
        .tech-logo {
            display: flex;
            align-items: center;
            text-decoration: none;

            .logo-image {
                height: 40px;
                margin-right: 10px;
            }

            .tech-brand-name {
                font-size: 22px;
                font-weight: 700;
                color: #333;
                margin-right: 8px;
                background: linear-gradient(135deg, #409EFF, #67C23A);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .tech-brand-tag {
                background: #409EFF;
                color: white;
                font-size: 12px;
                padding: 2px 8px;
                border-radius: 4px;
                font-weight: bold;
            }
        }
    }

    .tech-header-nav {
        display: flex;
        align-items: center;
    }

    .tech-nav-menu {
        display: flex;
        align-items: center;
        height: 100%;
    }

    .tech-nav-item {
        position: relative;
        height: 80px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;
        transition: all 0.3s ease;

        .tech-nav-text {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            position: relative;
            z-index: 1;
            transition: all 0.3s ease;
        }

        .tech-nav-line {
            position: absolute;
            bottom: 20px;
            left: 20px;
            width: calc(100% - 40px);
            height: 3px;
            background: #409EFF;
            transform: scaleX(0);
            transform-origin: center;
            transition: transform 0.3s ease;
        }

        &:hover {
            .tech-nav-text {
                color: #409EFF;
            }

            .tech-nav-line {
                transform: scaleX(1);
            }
        }

        &.active {
            .tech-nav-text {
                color: #409EFF;
                font-weight: 600;
            }

            .tech-nav-line {
                transform: scaleX(1);
            }
        }
    }

    .tech-mobile-menu {
        display: none;
        font-size: 24px;
        color: #333;
        cursor: pointer;
        margin-left: 20px;
    }

    .tech-mobile-nav {
        position: fixed;
        top: 80px;
        left: 0;
        width: 100%;
        background: white;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
        transform: translateY(-100%);
        opacity: 0;
        transition: all 0.3s ease;
        z-index: 999;

        &.show {
            transform: translateY(0);
            opacity: 1;
        }

        .tech-mobile-item {
            padding: 15px 20px;
            border-bottom: 1px solid #eee;
            font-size: 16px;
            color: #333;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
                background: #f5f7fa;
                color: #409EFF;
            }

            &.active {
                color: #409EFF;
                font-weight: 600;
                background: #f5f7fa;
            }
        }
    }

    @media (max-width: 992px) {
        .tech-nav-item {
            padding: 0 15px;
        }
    }

    @media (max-width: 768px) {
        .tech-nav-menu {
            display: none;
        }

        .tech-mobile-menu {
            display: block;
        }
    }

    @media (max-width: 576px) {
        .tech-header-container {
            height: 60px;
        }

        .tech-header-brand {
            .tech-logo {
                .logo-image {
                    height: 30px;
                }

                .tech-brand-name {
                    font-size: 18px;
                }

                .tech-brand-tag {
                    font-size: 10px;
                    padding: 1px 6px;
                }
            }
        }

        .tech-mobile-nav {
            top: 60px;
        }
    }
}
</style>
